const CircularProgress = () => {
  return (
    <svg viewBox="0 0 50 50" width="50">
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="#37A0F6"
        strokeWidth="3"
        strokeDasharray="80, 40"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="1s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-dashoffset"
          values="0;-120"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};

export default CircularProgress;
